import WaistForm from './WaistForm';
import WaistHistory from './WaistHistory';

export default function AdminWaistModal({ user, history, onClose, onUpdated }) {
  return <><div className="modal show d-block" role="dialog" aria-modal="true" aria-label={`腰圍紀錄 - ${user.name}`} tabIndex={-1}>
    <div className={`modal-dialog ${history ? 'modal-xl' : ''}`}><div className="modal-content">
      <div className="modal-header"><h5 className="modal-title">{history ? '腰圍歷史紀錄' : '新增腰圍'} - {user.name}</h5><button className="btn-close" aria-label="關閉" onClick={onClose} /></div>
      <div className="modal-body">{history ? <WaistHistory key={user.userId} userId={user.userId} admin onUpdated={onUpdated} /> : <WaistForm key={user.userId} userId={user.userId} admin onSuccess={() => { onUpdated(); onClose(); }} onCancel={onClose} />}</div>
    </div></div>
  </div><div className="modal-backdrop show" /></>;
}
